export default remote => ({
    all: (website, params) => remote.get(`content/all/${website}`, {params: params}),
    type: (website, type, params) => remote.get(`content/pages/${website}/${type}`, {params: params}),
    faqCategories: (website) => remote.get(`content/faq/categories/${website}`),
    faqCategory: (website, slug) => remote.get(`content/faq/category/${website}/${slug}`),
    query: (query) => remote.post(`content/query/any-flight`, query)
});
